import { MyApp } from "./app.component";
import { BrowserModule } from "@angular/platform-browser";
import { ErrorHandler, NgModule } from "@angular/core";
import { HttpModule } from "@angular/http";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { IonicApp, IonicErrorHandler, IonicModule } from "ionic-angular";

import { IonicStorageModule } from "@ionic/storage";

import { SignaturePadModule } from "angular2-signaturepad";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";

import { AuthProvider } from "../providers/auth/auth";
import { ImageProvider } from '../providers/image/image';
import { DatabaseProvider } from '../providers/database/database';
import { PdfProvider } from '../providers/pdf/pdf';
import { PdfRxProvider} from '../providers/pdf/pdf_rx';
import { UtilityProvider } from '../providers/utility/utility';
import { DirectivesModule } from "../directives/directives.module";

import { AngularFireModule } from '@angular/fire';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFireFunctions } from '@angular/fire/functions';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireStorageModule } from '@angular/fire/storage';

import { HomePageModule } from "../pages/home/home.module";
import { PatientsPageModule } from "../pages/patients/patients.module";
import { PatientAddPageModule } from "../pages/patient-add/patient-add.module";
import { PatientDetailsPageModule } from "../pages/patient-details/patient-details.module";
import { PatientUploadPageModule } from "../pages/patient-upload/patient-upload.module";
import { PatientBatchPageModule } from "../pages/patient-batch/patient-batch.module";
import { OrdersPageModule } from "../pages/orders/orders.module";
import { OrderDetailsPageModule } from "../pages/order-details/order-details.module";
import { ReportsPageModule } from "../pages/reports/reports.module";
import { GroupsPageModule } from "../pages/groups/groups.module";
import { GroupsAddPageModule } from "../pages/groups-add/groups-add.module";

import { AdminClinicsPageModule } from "../pages/admin-clinics/admin-clinics.module";
import { AdminClinicsAddPageModule } from "../pages/admin-clinics-add/admin-clinics-add.module";
import { AdminUsersPageModule } from "../pages/admin-users/admin-users.module";
import { AdminUsersAddPageModule } from "../pages/admin-users-add/admin-users-add.module";
import { AdminOrdersPageModule } from "../pages/admin-orders/admin-orders.module";
import { AdminNursinghomePageModule } from "../pages/admin-nursinghome/admin-nursinghome.module";
import { AdminPrescriptionsPageModule } from "../pages/admin-prescriptions/admin-prescriptions.module";
import { AdminPrescriptionsNotePageModule } from "../pages/admin-prescriptions-note/admin-prescriptions-note.module";
import { AdminUtilityPageModule } from "../pages/admin-utility/admin-utility.module";
import { AdminSuppliesPageModule } from "../pages/admin-supplies/admin-supplies.module";

import { ClinicDoctorsPageModule } from "../pages/clinic-doctors/clinic-doctors.module";
import { ClinicDoctorsAddPageModule } from "../pages/clinic-doctors-add/clinic-doctors-add.module";
import { ClinicSuppliesDefaultPageModule } from "../pages/clinic-supplies-default/clinic-supplies-default.module";

import { LoginPageModule } from "../pages/login/login.module";
import { AdminSuppliesAddPageModule } from "../pages/admin-supplies-add/admin-supplies-add.module";
import { SuppliesPageModule } from "../pages/supplies/supplies.module";
import { AdminSuppliesUploadPageModule } from "../pages/admin-supplies-upload/admin-supplies-upload.module";
import { OrderProvider } from '../providers/order/order';
import { ENV } from '@app/env'
import {TooltipController, TooltipsModule} from "ionic-tooltips";
import { MatDatepickerModule }  from '@angular/material/datepicker'
import { MatFormFieldModule }  from '@angular/material/form-field'
import { MatInputModule }  from '@angular/material/input'
import { MatNativeDateModule }  from '@angular/material'

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

@NgModule({
  declarations: [
    MyApp
    ],
  imports: [
    BrowserModule,
    HttpModule,
    HttpClientModule,
    SignaturePadModule,
    BrowserAnimationsModule,
    TooltipsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatInputModule,
    IonicModule.forRoot(MyApp, {
      iconMode: "md",
      mode: "md",
      tabsPlacement: "bottom",
      scrollAssist: false,
      autoFocusAssist: false
    }),
    IonicStorageModule.forRoot(),
    AngularFireModule.initializeApp(ENV.FIREBASE_CONFIG),
    AngularFirestoreModule,
    AngularFireStorageModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
    LoginPageModule,
    HomePageModule,
    PatientsPageModule,
    PatientBatchPageModule,
    PatientDetailsPageModule,
    PatientAddPageModule,
    PatientUploadPageModule,
    OrdersPageModule,
    OrderDetailsPageModule,
    DirectivesModule,
    ReportsPageModule,
    SuppliesPageModule,
    GroupsPageModule,
    GroupsAddPageModule,
    AdminClinicsPageModule,
    AdminClinicsAddPageModule,
    AdminSuppliesPageModule,
    AdminSuppliesAddPageModule,
    AdminSuppliesUploadPageModule,
    AdminOrdersPageModule,
    AdminNursinghomePageModule,
    AdminPrescriptionsPageModule,
    AdminPrescriptionsNotePageModule,
    AdminUsersPageModule,
    AdminUsersAddPageModule,
    AdminUtilityPageModule,
    ClinicDoctorsPageModule,
    ClinicDoctorsAddPageModule,
    ClinicSuppliesDefaultPageModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [MyApp],
  providers: [
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    AuthProvider,
    ImageProvider,
    AngularFireAuth,
    AngularFireFunctions,
    DatabaseProvider,
    UtilityProvider,
    PdfProvider,
    PdfRxProvider,
    OrderProvider,
    TooltipController
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts